module.exports = __webpack_public_path__ + "assets/flat-tire.40db40e1.svg";